import { PinnedArtifactCard } from "./PinnedArtifactCard";
import { usePinnedArtifacts, usePinnedArtifactMutations } from "./usePinnedArtifacts";

interface PinnedArtifactsProps {
  projectId: string;
  // Whether the caller can curate the overview. Pinning and unpinning are
  // manager-gated; refreshing, added alongside the workflow drawer, is not.
  canCurate: boolean;
}

// The project's pinned artifacts, rendered for every member.
//
// Collapses to nothing when there are none: an empty prompt on the overview
// would be noise for members who cannot pin anything anyway.
export const PinnedArtifacts = ({ projectId, canCurate }: PinnedArtifactsProps) => {
  const { pinnedArtifacts, error } = usePinnedArtifacts(projectId);
  const { unpin } = usePinnedArtifactMutations(projectId);

  if (error || !pinnedArtifacts?.length) return null;

  return (
    <div>
      <h2 className="text-sm text-muted-foreground">Pinned artifacts ({pinnedArtifacts.length})</h2>
      <div className="mt-2 grid grid-cols-1 gap-3 lg:grid-cols-2">
        {pinnedArtifacts.map((pin) => (
          <PinnedArtifactCard
            key={pin.id}
            pin={pin}
            canCurate={canCurate}
            onUnpin={() => void unpin(pin)}
          />
        ))}
      </div>
    </div>
  );
};
